import service from "../service.js";

// get bank list
export const getBankInfo = (data) => {
  return service({
    url: "/v3/payment/bank/list",
    method: "POST",
    data,
  });
};

// get sms Code
export const getCode = (data) => {
  return service({
    url: "/v3/auth/getVerifyCode",
    method: "POST",
    data,
  });
};

// login
export const login = (data) => {
  return service({
    url: "/v3/auth/login/sms",
    method: "POST",
    data,
  });
};

// out login
export const outLogin = (data) => {
  return service({
    url: "/v3/auth/logout",
    method: "POST",
    data,
  });
};

// loginInfo
export const getInfor = (data) => {
  return service({
    url: "/v3/orders/loan/info",
    method: "POST",
    data,
  });
};

// 获取产品列表
export const getProduct = (data) => {
  return service({
    url: "/v3/product/list",
    method: "POST",
    data,
  });
};

// 创建临时订单
export const createOrderForm = (data) => {
  return service({
    url: "/v2/orders/order/create",
    method: "POST",
    data,
  });
};

// 试算
export const orderCalculate = (data) => {
  return service({
    url: "/v3/calculate",
    method: "POST",
    data,
  });
};

// 订单确认
export const orderConfirm = (data) => {
  return service({
    url: "/v3/orders/order/confirm",
    method: "POST",
    data,
  });
};

// 获取用户信息
export const getUserInforList = (data) => {
  return service({
    url: "/v3/account/info/get",
    method: "POST",
    data,
  });
};

// 修改 info-1 信息
export const editStep1Info = (data) => {
  return service({
    url: "/v3/account/base/update",
    method: "POST",
    data,
  });
};
// 修改 info-2 信息
export const editStep2Info = (data) => {
  return service({
    url: "/v3/account/contact/update",
    method: "POST",
    data,
  });
};
// 修改 info-3 信息
export const editStep3Info = (data) => {
  return service({
    url: "/v3/account/identity/verify",
    method: "POST",
    data,
  });
};
// 修改 info-4 信息
export const editStep4Info = (data) => {
  return service({
    url: "/v3/account/bank/card/update",
    method: "POST",
    data,
  });
};

// 身份证照片OCR识别
export const OCRgetCardInfo = (data) => {
  return service({
    url: "/v2/account/identity/detect8",
    method: "POST",
    type: "upload",
    data,
  });
};

// 活体认证
export const liveVerify = (data) => {
  return service({
    url: "/v2/account/live/verify",
    method: "POST",
    type: "upload",
    data,
  });
};

// 借款确认
export const loanConfirm = (data) => {
  return service({
    url: "/v3/orders/loan/confirm",
    method: "POST",
    data,
  });
};

// 还款信息
export const repayMentInfo = (data) => {
  return service({
    url: "/v3/account/center/order/home",
    method: "POST",
    data,
  });
};

// 创建还款流水
export const createRepayment = (data) => {
  return service({
    url: "/v3/repay/record/create",
    method: "POST",
    data,
  });
};

// 获取还款通道
export const getRepaymentList = (data) => {
  return service({
    url: "/v3/payment/channelInfo",
    method: "POST",
    data,
  });
};

// 还款手续费
export const repaymentDesc = (data) => {
  return service({
    url: "/v3/repay/tax/desc",
    method: "POST",
    data,
  });
};

// 获取历史订单列表
export const getHistoryOrderList = (data) => {
  return service({
    url: "/v3/ucenter/order/all",
    method: "POST",
    data,
  });
};
